var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormBox",
        { attrs: { title: "平 台 申 请" } },
        [
          _c(
            "div",
            {
              ref: "agreement",
              staticClass: "agreement",
              on: { scroll: _vm.scrollEvent }
            },
            [
              _vm._v(
                "\n             在申请实名认证服务（以下简称“认证”）前，请详细阅读本协议的所有内容。若您开始认证流程，即表示您充分理解并同意接受本协议的全部内容。"
              ),
              _c("br"),
              _vm._v("\n\n      一、服务内容"),
              _c("br"),
              _vm._v(
                "\n      本平台向您提供个人实名认证服务。认证指健康网平台用户签署实名认证服务协议，采用银行卡或身份证认证等方式对用户资料真实性进行的验证审核。经查证身份信息真实有效后，为用户提供个人实名认证的相关服务，包括：查询个人健康档案、检验检查报告查询、电子健康卡相关业务等。"
              ),
              _c("br"),
              _vm._v("\n\n      二、适用范围"),
              _c("br"),
              _vm._v("\n      认证适用于健康网平台的所有个人用户。"),
              _c("br"),
              _vm._v("\n\n      三、认证流程"),
              _c("br"),
              _vm._v(
                "\n      1、目前提供两种认证方式：银行卡认证和身份证认证。"
              ),
              _c("br"),
              _vm._v("\n      1）银行卡认证"),
              _c("br"),
              _vm._v(
                "\n      用户输入姓名、身份证号、发卡银行、银行卡号、预留手机号，获取验证码，直连银行系统进行校验。"
              ),
              _c("br"),
              _vm._v("\n      2）身份证认证"),
              _c("br"),
              _vm._v(
                "\n      用户输入姓名、身份证号，上传身份证照正反面，通过人工审核方式核验，通常需3个工作日。"
              ),
              _c("br"),
              _vm._v(
                "\n\n      2、通过实名认证的用户不能自行修改实名相关信息，包括但不限于个人姓名以及身份证件号码等。"
              ),
              _c("br"),
              _vm._v("\n\n      四、服务内容"),
              _c("br"),
              _vm._v("\n      1、健康档案查询"),
              _c("br"),
              _vm._v(
                "\n      健康档案查询，仅支持查询本人记录，且需完成实名认证。所有搜集到的健康档案数据信息，在未经您本人允许的情况下，不会泄露和公布给第三方。"
              ),
              _c("br"),
              _vm._v(
                "\n      包含3部分：个人健康信息，电子健康档案，就医图片记录。"
              ),
              _c("br"),
              _vm._v(
                "\n      （1）个人健康信息——由用户/家庭医生补充完善的居民健康档案数据；"
              ),
              _c("br"),
              _vm._v(
                "\n      （2）电子健康档案——是居民在医疗服务、健康管理过程中产生的电子化记录，包括：门（急）诊、住院、体检、全科诊疗、预防保健等17种类型的诊疗记录摘要；"
              ),
              _c("br"),
              _vm._v(
                "\n      （3）就医图片记录——由用户主动填写及上传的就医相关纸质资料。"
              ),
              _c("br"),
              _vm._v(
                "\n      目前正处在健康档案数据陆续采集完善过程中，可能会导致个别用户数据不完整，敬请见谅。"
              ),
              _c("br"),
              _vm._v("\n\n      2、检验检查报告查询"),
              _c("br"),
              _vm._v(
                "\n      报告查询，仅支持查询本人在全市支持互联互通的医疗机构的检验检查记录，且需完成实名认证。所有呈现的报告数据信息，在未经您本人允许的情况下，不会泄露和公布给第三方。同时报告文件不提供下载功能、不支持截屏，请勿使用拍照等方式存储报告内容。"
              ),
              _c("br"),
              _vm._v("\n      关于报告的免责申明："),
              _c("br"),
              _vm._v(
                "\n      （1）查询结果所显示的报告数据，均由用户进行检验/检查所在医疗机构提供，平台仅负责信息文本格式上的表述与转呈，不做任何实质内容的变更。"
              ),
              _c("br"),
              _vm._v(
                "\n      （2）检验/检查报告对检查过程中身体情况的客观记录，仅供用户、临床医生鉴别诊断和参考，报告本身并非对疾病的诊断和证明。"
              ),
              _c("br"),
              _vm._v(
                "\n      （3）由于查询结果同步的报告数据，在一定时间内允许医疗机构修订。如报告详情呈现的PDF电子版内容与医疗机构直接提供的纸质报告有表述不同或差异，以纸质报告为准。"
              ),
              _c("br"),
              _vm._v(
                "\n      目前正处在报告数据互联互通完善期，可能会导致个别用户数据不完整，敬请见谅。"
              ),
              _c("br"),
              _vm._v("\n\n      3、电子健康卡业务"),
              _c("br"),
              _vm._v(
                "\n      电子健康卡为非实体卡，通过二维码的形式展示，通过“面对面”方式进行交互使用。电子健康卡在线申领需完成实名认证，目前只允许通过银行卡方式认证的实名认证用户。认证过程，需使用身份证、储蓄卡，如无身份证号、银行卡号则无法申领。"
              ),
              _c("br"),
              _vm._v("\n      关于申领电子健康卡的免责申明："),
              _c("br"),
              _vm._v(
                "\n      （1）实名认证时填写的姓名、身份证号用于生成国家级电子健康卡ID，并与医院建档信息匹配，请谨慎操作。\n      如个人原因填写错误，造成无法关联匹配医院就诊卡信息，将无法修改。"
              ),
              _c("br"),
              _vm._v(
                "\n      （2）电子健康卡二维码可在医院通过扫码方式进行相关业务。静态二维码，用于预约挂号、门诊缴费、报告查询等就医业务功能；动态二维码，用于支付结算、健康档案授权等更高安全等级的校验；(暂未开通）"
              ),
              _c("br"),
              _vm._v(
                "\n      （3）如需了解更多信息，可查看“电子健康卡使用指引”及“支持电子健康卡就诊医院”。"
              ),
              _c("br"),
              _vm._v("\n      五、隐私保护"),
              _c("br"),
              _vm._v(
                "\n      1、您在认证时提交给本平台的认证资料，即不可撤销的授权由本平台保留。本平台承诺除法定或约定的事由外，不公开或编辑或透露您的认证资料及保存在本平台的非公开内容用于商业目的，但下列情况除外："
              ),
              _c("br"),
              _vm._v("\n      1) 您授权本平台透露的相关信息；"),
              _c("br"),
              _vm._v("\n      2) 本平台向国家司法及行政机关提供；"),
              _c("br"),
              _vm._v(
                "\n      3)\n      第三方和本平台一起为用户提供服务时，该第三方向您提供服务所需的相关信息。"
              ),
              _c("br"),
              _vm._v(
                "\n\n      2、我们将采取合理的方式以保护您个人资料的安全。我们将使用必要的可以获得的安全技术和程序来保护您的个人资料不被未经授权的访问、使用或泄漏。"
              ),
              _c("br"),
              _vm._v("\n\n      六、免责条款"),
              _c("br"),
              _vm._v("\n      下列情况时本平台无需承担任何责任："),
              _c("br"),
              _vm._v(
                "\n\n      1、由于您将平台账户密码告知他人或未保管好自己的密码或与他人共享平台账户或任何其他非本平台的过错，导致您的个人资料泄露。"
              ),
              _c("br"),
              _vm._v(
                "\n\n      2、由于不可抗力，例如出现故障、火灾、水灾、雷击、地震、洪水、台风、龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件等及其他非因本平台过错而造成的认证信息泄露、丢失、被盗用或被篡改等。"
              ),
              _c("br"),
              _vm._v(
                "\n\n      3、任何平台用户（包括未成年人用户）向本平台提供错误、不完整、不实信息等造成不能通过认证或遭受任何其他损失。"
              ),
              _c("br"),
              _vm._v("\n\n      七、修改和解释权"),
              _c("br"),
              _vm._v(
                "\n      1、本平台有权单方随时修改或变更本协议内容，并通过平台公告变更后的协议文本，无需单独通知您。本协议进行任何修改或变更后，您还继续使用实名认证服务的，即代表您已阅读、了解并同意接受变更后的协议内容，且不得因此而要求任何补偿或赔偿；您如果不同意变更后的协议内容，可停止使用我们所提供的服务。"
              ),
              _c("br"),
              _vm._v(
                "\n\n      2、我们保留对本协议条款、产品和服务以及我们所提供的产品和服务的相关官方网站的最终解释权。\n    "
              )
            ]
          ),
          _c("div", { staticStyle: { height: "10px" } }),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.checkboxDisabled },
              model: {
                value: _vm.checked,
                callback: function($$v) {
                  _vm.checked = $$v
                },
                expression: "checked"
              }
            },
            [_vm._v("我已阅读《实名认证服务协议》")]
          ),
          _c("div", { staticStyle: { height: "10px" } }),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticClass: "login-btn",
                  staticStyle: { width: "100%" },
                  attrs: { loading: _vm.loading, type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v("申请")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Dialog",
        { ref: "dialog", attrs: { title: "平台申请" } },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "验证码", prop: "verificationCode" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.verificationCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "verificationCode", $$v)
                      },
                      expression: "form.verificationCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("form")
                        }
                      }
                    },
                    [_vm._v("确认")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }